export enum RelativeDates {
    Today = "Today",
    Yesterday = "Yesterday",
    Last7Days = "Last7Days",
    Last14Days = "Last14Days",
    Last30Days = "Last30Days",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    WeekToDate = "WeekToDate",
    MonthToDate = "MonthToDate",
}
export type RelativeDateInfo = {
    name: RelativeDates;
    formatedName: string;
    startDate: Date;
    endDate: Date;
};

/**
 * The corner radius of the date popover and of the panel's own surfaces (the presets and the calendar). They share one
 * radius so the panel's surfaces, which are flush with the popover's edges, line up with its corners. A surface that
 * hosts the panel flush with its edges takes this radius too.
 */
export const DATE_PICKER_RADIUS = "lg";

export const TIME_RANGE_TOOLTIP = "Please enter a valid time range.";

export const MISSING_END_DATE_TOOLTIP = "Please select an end date.";

export const MAX_HOURS = 23;
export const MAX_MINUTES_OR_SECONDS = 59;
export const MAX_MILLISECONDS = 999;
